import * as React from 'react';

import { SVGProps } from '../../types';

export const IconThumbsUpSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M17 19L10 19C9.44771 19 9 18.5523 9 18L8.99998 10.389C8.99998 10.1388 9.09377 9.89769 9.26283 9.71326L14.4186 4.08882C14.4609 4.04266 14.5347 4.0463 14.5723 4.09639L15.2583 5.01114C15.7129 5.61718 15.786 6.42801 15.4472 7.10558L14.2236 9.55278C13.8911 10.2177 14.3746 11 15.118 11L18.5 11C20.3541 11 21.4125 13.1167 20.3 14.6C20.1053 14.8596 20 15.1754 20 15.5L20 16C20 17.6569 18.6569 19 17 19Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M3 11C3 10.4477 3.44772 10 4 10H6V19H4C3.44772 19 3 18.5523 3 18V11Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);
